<template>
  <div class="simple-tree">
    <div v-for="(value, key) in data" :key="key" class="node">
      <div class="entry" @click.stop="onNodeClick(key, value)">
        <span class="key">{{ key }}:</span>
        <span v-if="isObjectOrArray(value)" class="value-placeholder" @click.stop="toggle(key)">
          {{ expanded[key] ? '▼' : '▶' }} {{ Array.isArray(value) ? `Array[${value.length}]` : 'Object' }}
        </span>

        <span v-else class="value-simple">
          {{ value }}
        </span>
      </div>
      <simple-json-tree
        v-if="isObjectOrArray(value) && expanded[key]"
        :data="value"
        :current-path="buildPath(key)"
        @node-click="$emit('node-click', $event)"
        class="nested"
      ></simple-json-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleJsonTree', // O nome é essencial para a recursão
  props: {
    data: {
      type: [Object, Array],
      required: true
    },
    currentPath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      expanded: {}
    }
  },
  methods: {
    isObjectOrArray (value) {
      return typeof value === 'object' && value !== null
    },
    buildPath (key) {
      return this.currentPath ? `${this.currentPath}.${key}` : String(key)
    },
    onNodeClick (key, value) {
      // Emite o evento com o caminho completo, a chave e o valor
      this.$emit('node-click', {
        path: this.buildPath(key),
        key: key,
        value: value
      })
    },
    toggle (key) {
      this.$set(this.expanded, key, !this.expanded[key])
    }
  }
}
</script>

<style scoped>
.simple-tree {
  font-family: monospace;
  font-size: 14px;
}
.nested {
  margin-left: 20px;
  border-left: 1px solid #ccc;
  padding-left: 10px;
}
.entry {
  cursor: pointer;
}
.entry:hover {
  background-color: #f0f0f0;
}
.key {
  color: #881391; /* Roxo para chaves */
}
.value-simple {
  color: #c82829; /* Vermelho para valores */
  margin-left: 5px;
}
.value-placeholder {
  color: #4271ae; /* Azul para objetos/arrays */
  font-style: italic;
  margin-left: 5px;
}
</style>
